import { useState } from "react"
import { shape, number, string, bool, array } from "prop-types"
import ReservationContactSection from "components/admin/Reservation/reservation_contact_section"
import SignUpSelections from "components/admin/Reservation/SignUpSelections"
import { Pane } from "components/ui"
import axios from "axios"
import pcoUrl from "pco-url"

const Registrations = ({
  registration,
  registrationContact,
  event,
  attendeeTypes,
  simpleAttendees,
  isAdmin,
  registerForSeparateTimesEnabled,
  signupTimes
}) => {
  const [isEditing, setIsEditing] = useState(false)

  const handleRegistrationContactChange = contact => {
    let id = null

    if (contact) {
      id = contact.account_center_id

      axios.patch(
        `${pcoUrl(window.railsEnv)("api")}/registrations/v2/events/${event.id}/registrations/${
          registration.id
        }`,
        {
          data: {
            id: registration.id,
            attributes: { responsible_person_id: id }
          }
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": $.rails.csrfToken()
          }
        }
      )
    }
  }

  return (
    <Pane marginBottom={2}>
      <SignUpSelections
        event={event}
        attendeeTypes={attendeeTypes}
        simpleAttendees={simpleAttendees}
        signUpPath={`registrations/${registration.id}`}
        isEditing={isEditing}
        handleEditClick={() => setIsEditing(!isEditing)}
        registrationIsCanceled={registration.isCancelled}
        registrationId={registration.id}
        registerForSeparateTimesEnabled={registerForSeparateTimesEnabled}
        signupTimes={signupTimes}
      />
      <Pane.Body className="line">
        <ReservationContactSection
          contact={registrationContact}
          localStorageKey={`registration-${registration.id}`}
          onContactChange={handleRegistrationContactChange}
          isAdmin={isAdmin}
          isEditing={isEditing}
          isClearable={false}
        />
      </Pane.Body>
    </Pane>
  )
}

Registrations.propTypes = {
  registration: shape({
    id: number,
    isCancelled: string
  }),
  registrationContact: shape({}),
  event: shape({
    id: number
  }),
  isAdmin: bool,
  attendeeTypes: array,
  simpleAttendees: array,
  registerForSeparateTimesEnabled: bool,
  signupTimes: array
}

export default Registrations
